import { Skeleton, Empty, Tabs } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../Stores'
import { CHAT_SECTIONS } from '../../Helpers/chatSections'
import ChatSearch from './ChatSearch'
import ChatListItem from './ChatListItem'

const ChatList = observer(() => {
  const { chatStore } = useStore()
  const { filteredChats, isLoading } = chatStore

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Розділи НАД усім списком (Бітрікс-патерн): таб — це контекст,
          у якому живуть і пошук, і список. П'ять розділів (із «Заявками»)
          мають уміститися в 300 px колонки без «…» — звідси дрібніший
          шрифт і щільніший крок */}
      <Tabs
        size="small"
        activeKey={chatStore.activeSection}
        onChange={(key) => chatStore.setActiveSection(key)}
        items={CHAT_SECTIONS.map((s) => ({ key: s.key, label: <span style={{ fontSize: 13 }}>{s.label}</span> }))}
        tabBarStyle={{ margin: 0, paddingLeft: 8, paddingRight: 8 }}
        tabBarGutter={10}
      />

      <ChatSearch />

      <div className="chat-scroll" style={{ flex: 1, overflowY: 'auto' }}>
        {isLoading ? (
          <div style={{ padding: 12 }}>
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, padding: '10px 0' }}>
                <Skeleton.Avatar active size={44} />
                <div style={{ flex: 1 }}>
                  <Skeleton.Input active size="small" style={{ width: '60%', marginBottom: 6 }} />
                  <Skeleton.Input active size="small" style={{ width: '80%' }} />
                </div>
              </div>
            ))}
          </div>
        ) : filteredChats.length === 0 ? (
          <Empty
            description={chatStore.searchQuery ? 'Чатів не знайдено' : 'Немає чатів'}
            style={{ marginTop: 48 }}
          />
        ) : (
          filteredChats.map((chat) => (
            <ChatListItem key={chat.id} chat={chat} />
          ))
        )}
      </div>
    </div>
  )
})

export default ChatList
